__turbopack_context__.v({
  "caption": "Carousel-module__Q0CNla__caption",
  "carousel": "Carousel-module__Q0CNla__carousel",
  "image": "Carousel-module__Q0CNla__image",
  "root": "Carousel-module__Q0CNla__root",
  "slide": "Carousel-module__Q0CNla__slide",
});
